module.exports = __webpack_public_path__ + "static/media/1033157.ba0ed3ff.jpg";